<div id="menuOverlay" (click)="closeNav()"></div>
<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
  <div class="logo-div sidemenu-logo-div" routerLink="/">
    <img src="assets/images/pups-logo-header.svg" alt="">
  </div>
  <div *ngIf="isBusiness || employee" class="profile-container text-center">
    <a *ngIf="!employee" routerLink="/profile">{{ accountDetails?.company_name | slice:0:15}}{{ accountDetails?.company_name?.length > 15 ? '..' : '' }}</a>

    <a *ngIf="employee" routerLink="/profile">{{ accountDetails?.first_name | slice:0:15}}{{ accountDetails?.first_name?.length > 15 ? '..' : '' }}</a>
  </div>
  <li *ngIf="login == '2' || isBusiness"> <a routerLink="/dashboard" class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a> </li>
  
  <!-- <li *ngIf="isBusiness"><a *ngIf="login == '1'" [ngClass]="{ 'active': url == 'employees'}" class="active" routerLink="/employees">{{'Employees' | translate}}</a></li>
  <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()">{{'DTS' | translate}} </a></li>

  <li>
    <a *ngIf="login == '2'" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
  </li>
  <li>
    <a routerLink="/experience" *ngIf="login == '2'">{{'Experience' | translate}}</a>
  </li>
  <li>
    <a routerLink="/cnss" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
  </li>
  <li>
    <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
  </li>
  <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li> -->
  <li *ngIf="login"><a routerLink="/profile">{{'Profile' | translate}}</a></li>
  <li><a routerLink="/contact-us">{{'Contact' | translate}}</a></li>
  <li *ngIf="currentValue && loginStatus == 0"><a (click)="openChangePassword()">{{'Change Password' | translate}}</a></li>
  <li [hidden]="!currentValue"><a href="" (click)="logout()">{{'Logout' | translate}}</a></li>
  <li [hidden]="currentValue" class="pulse">
    <a class="register-button" routerLink="/verify-employer" (click)="closeNav()">{{'Verify' | translate}}</a>
  </li>
  <li [hidden]="currentValue">
    <a class="login-button" data-toggle="modal" data-target="#signinModal" (click)="closeNav()">{{'Login' | translate}}</a>
  </li>
  <div class="language-container">
    <form [formGroup]="languageForm">

      <div class="toggle-button-cover">
        <div class="button-cover">
          <div class="button r" id="button-6">
            <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
            <div class="knobs"></div>
            <div class="layer"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<header class="header-home-page">
  <div class="header-section">
    <div class="display-flex-head">
      <div class="button_container" (click)="openNav()">
        <div><span class="top"></span><span class="middle"></span><span class="bottom">
          </span></div>
      </div>
      <div class="logo-div">
        <img src="assets/images/pups-logo-header.svg" alt="">
      </div>

      

      <div class="flex-right-section mobile-side-menu-display">

        <div class="btn-div" [hidden]="currentValue">
          <button class="reg-btn pulse" routerLink="/verify-employer">
            <img src="assets/images/header-reg-arrow.png" alt="">
            {{'Verify' | translate}}
          </button>
  
          <button class="login-btn" (click)="showLogin()">
            <img src="assets/images/header-login-arrow.png" alt="">
            {{'Login' | translate}}
          </button>
        </div>

        <div class="ul-section" *ngIf="currentValue">
          <ul class="ul-list">
            <li *ngIf="login == '1'"> <a routerLink="/dashboard" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a> </li>
            <!-- <li *ngIf="isBusiness"><a class=""  (click)="openPaymentDetailsModal()" >{{'Payment details' | translate}} </a></li> -->
            <!-- <li *ngIf="isBusiness" class="dropdown-menu-item">
              <a routerLink="/employees" class="" [ngClass]="{ 'active': url == 'employees'}">{{'Employee mobility' | translate}}</a>
              <ul class="dropdown-menu">
                <li> <a (click)="navigateToAddEmployee()">{{'Hiring' | translate}}</a></li>
                <li class="dropdown-submenu">
                  <a (click)="navigateToCnssEmployeeRegistration()">{{'CNSS employee registration' | translate}} </a>
                </li>
                <li class="dropdown-submenu">
                  <a (click)="navigateToCnamgsEmployeeRegistration()">{{'CNAMGS employee registration' | translate}} </a>
                </li>
                <li>
                  <a  routerLink="/employee-termination">{{'Termination' | translate}}</a>
                </li>
              </ul>
            </li>
           
             

            <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()" [ngClass]="{ 'active': url == 'cnss-reports' || url == 'cnss-reportList' || url == 'cnss-report-view'}">{{'DTS' | translate}} </a></li>
            <li>
              <a *ngIf="login == '2'" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
            </li>
            <li>
              <a routerLink="/experience" *ngIf="login == '2'">{{'Experience' | translate}}</a>
            </li>
            <li>
              <a routerLink="/cnss" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
            </li>
            <li>
              <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
            </li>
            <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li> -->
        
            <li *ngIf="currentValue && loginStatus == 0"><a (click)="openChangePassword()">{{'Change Password' | translate}}</a></li>
            <li [hidden]="!currentValue"><a routerLink="/" (click)="logout()">{{'Logout' | translate}}</a></li>
          </ul>
        </div>
        <div class="language-toggle-section">
          <div class="dropdown">
            <div class="toggle-button-cover">
              <div class="button-cover">
                <div class="button home-page-toggle-btn r" id="button-6">
                  <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="home-banner-section">
  <!-- swiper.component.html -->
  <div class="swiper-container home-banner-swiper">
    <div class="swiper-wrapper">

      <div class="swiper-slide">
        <div class="swiper-inner-bg-section">
          <div class="inner-content-section">
            <div class="content"> 
              <div class="img-section">
                <img src="assets/images/banner-logo-white.svg" alt="home-banner-img-1">
                <img src="assets/images/banner-cnamgs-logo-border.svg" alt="home-banner-img-1">
              </div>
              <h2>{{'For inclusive and sustainable social protection' | translate}}</h2>
              <!-- <p>{{'For inclusive and sustainable social protection in the Gabonese Republic' | translate}}</p> -->
              <button
                class="swiper-reg-btn"
                *ngIf="currentValue; else registerNow"
                [routerLink]="'/dashboard'"
              >
                <img src="assets/images/swiper-reg-arrow.png" alt="">
                {{ 'Dashboard' | translate }}
              </button>
              <ng-template #registerNow>
                <button
                  class="swiper-reg-btn"
                  routerLink="/verify-employer"
                  type="button"
                >
                  <img src="assets/images/swiper-reg-arrow.png" alt="">
                  {{ 'Verify Now' | translate }}
                </button>
              </ng-template>
            </div>
            <div class="banner-img-section">
              <img src="assets/images/home-banner-person-1.png" alt="home-banner-img-1">
            </div>
          </div>
          <!-- <p class="swiper-banner-bottom-text">{{'For inclusive and sustainable social protection in the Gabonese Republic' | translate}}
          </p> -->
        </div>
      </div>

      <div class="swiper-slide">
        <div class="swiper-inner-bg-section swiper-2">
          <div class="inner-content-section">
            <div class="banner-img-section">
              <img src="assets/images/home-banner-person-2.png" alt="home-banner-img-1">
            </div>
            <div class="content padding-top-5-mobile">
              <div class="img-section">
                <img src="assets/images/banner-logo-white.svg" alt="home-banner-img-1">
                <img src="assets/images/banner-cnamgs-logo-border.svg" alt="home-banner-img-1">
              </div>
              <h2>{{'For inclusive and sustainable social protection' | translate}}</h2>
              <!-- <p>{{'For inclusive and sustainable social protection in the Gabonese Republic' | translate}}</p> -->
              <button
              class="swiper-reg-btn"
              *ngIf="currentValue; else registerNow"
              [routerLink]="'/dashboard'"
            >
              <img src="assets/images/swiper-reg-arrow.png" alt="">
              {{ 'Dashboard' | translate }}
            </button>
            <ng-template #registerNow>
              <button
                class="swiper-reg-btn"
                routerLink="/verify-employer"
                type="button"
              >
                <img src="assets/images/swiper-reg-arrow.png" alt="">
                {{ 'Verify Now' | translate }}
              </button>
            </ng-template>
            </div>
            
          </div>
          <!-- <p class="swiper-banner-bottom-text">{{'For inclusive and sustainable social protection in the Gabonese Republic' | translate}}
          </p> -->
        </div>
      </div>

    </div>
  </div>
</div>

<div class="home-section-2">
  <div class="top-section">
    <div class="content-1">
      <button class="get-started-btn">{{'Get Started' | translate}}</button>
      <h3>{{'Getting Started' | translate}} <br> {{'with' | translate}} <span class="color-green">{{'PUPS' | translate}}</span></h3>
    </div>

    <div class="content-2">
      <p>{{'Register on the PUPS platform, connect your unique PUPS ID, and manage all CNAMGS and CNSS services through one unified system.' | translate}}</p>
    </div>
  </div>

  <div class="bottom-section-home">
    <div class="home-card bg-1">
      <h5>{{'Step 01' | translate}}</h5>
      <div class="img-section">
        <img src="assets/images/home-card-img-1.png" alt="home-card-img-1">
        <p>{{'Verify-card' | translate}}</p>
      </div>
      <p>{{'Verify against unique ID' | translate}}</p>
    </div>

    <div class="home-card bg-2">
      <h5>{{'Step 02' | translate}}</h5>
      <div class="img-section">
        <img src="assets/images/home-card-img-2.png" alt="home-card-img-1">
        <p>{{'Log in' | translate}}</p>
      </div>
      <p>{{'Create your login details' | translate}}</p>
    </div>

    <div class="home-card bg-3">
      <h5>{{'Step 03' | translate}}</h5>
      <div class="img-section">
        <img src="assets/images/home-card-img-3.png" alt="home-card-img-1">
        <p>{{'Manage Services' | translate}} </p>
      </div>
      <p>{{'Manage your company with PUPS' | translate}}</p>
    </div>
  </div>
</div>

<div class="home-section-3">
  <div class="section-3-outter-card">
    <div class="section-3-inner-card">

      <p class="bg-para">{{'About PUPS' | translate}}</p>

      <h4>{{'Unified Social Protection' | translate}} <br> {{'Platform' | translate}}</h4>
      <p>{{'about para 1' | translate}}.
      {{'about para 2' | translate}}</p>
      <button class="section-know-more-btn cursor-pointer" (click)="handleArrowClick()">{{'Know More' | translate}} <img src="assets/images/section-3-arrow.png" alt=""></button>
    </div>
  </div>
</div>

<div class="home-section-4">
  <div class="section-4-top">
    <p class="para-bg">{{'The Features' | translate}}</p>
    <div class="section-4-grid-div">
      <div class="section-4-content-1">
        
        <div class="section-4-content-1-text">
          <h3>{{'One unified setup for' | translate}} <span class="color-green">{{'CNAMGS and CNSS' | translate}}</span></h3>
          <p>{{'A single, centralized system that allows employers to register, declare salaries, calculate contributions, make payments, and access reports for both CNAMGS and CNSS—eliminating the need for multiple platforms.' | translate}}</p>
        </div>
      </div>
      <div class="section-4-content-2">
        <div class="svg-card-home">
          <div class="svg-div">
            <svg class="svg-img" viewBox="0 0 561 215" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_270_167" fill="white">
                <path
                  d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z" />
              </mask>
              <path
                d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z"
                fill="var(--primary-blue)" fill-opacity="0.02" />
              <path
                d="M541 0V2C550.941 2 559 10.0589 559 20H561H563C563 7.84974 553.15 -2 541 -2V0ZM561 20H559V133H561H563V20H561ZM541 153V151H473V153V155H541V153ZM453 173H451V195H453H455V173H453ZM433 215V213H20V215V217H433V215ZM20 215V213C10.0589 213 2 204.941 2 195H0H-2C-2 207.15 7.84974 217 20 217V215ZM0 195H2V121H0H-2V195H0ZM20 101V103H60V101V99H20V101ZM80 81H82V20H80H78V81H80ZM100 0V2H541V0V-2H100V0ZM80 20H82C82 10.0589 90.0589 2 100 2V0V-2C87.8497 -2 78 7.84974 78 20H80ZM453 195H451C451 204.941 442.941 213 433 213V215V217C445.15 217 455 207.15 455 195H453ZM60 101V103C72.1503 103 82 93.1503 82 81H80H78C78 90.9411 69.9411 99 60 99V101ZM473 153V151C460.85 151 451 160.85 451 173H453H455C455 163.059 463.059 155 473 155V153ZM0 121H2C2 111.059 10.0589 103 20 103V101V99C7.84974 99 -2 108.85 -2 121H0ZM561 133H559C559 142.941 550.941 151 541 151V153V155C553.15 155 563 145.15 563 133H561Z"
                fill="#F3F3F3" mask="url(#path-1-inside-1_270_167)" />
            </svg>
      
          </div>
      
          <div class="svg-content-section">
            <div class="round-img">
              <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
            </div>
            <div class="arrow-img" (click)="handleArrowClick()">
              <img src="assets/images/svg-img-arrow.png" alt="section-4-arrow-img">
            </div>
      
            <div class="svg-content">
              <div class="svg-content-header">
                <div class="round-img-inner">
                  <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
                </div>
                <h3>{{'Manage health insurance with CNAMGS' | translate}}</h3>
              </div>
             
              <p>{{'Easily access health insurance services and benefits through a centralized platform.' | translate}}</p>
            </div>
          </div>
        </div>
      
        <div class="svg-card-home">
          <div class="svg-div">
            <svg class="svg-img" viewBox="0 0 561 215" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_270_167" fill="white">
                <path
                  d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z" />
              </mask>
              <path
                d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z"
                fill="var(--primary-blue)" fill-opacity="0.02" />
              <path
                d="M541 0V2C550.941 2 559 10.0589 559 20H561H563C563 7.84974 553.15 -2 541 -2V0ZM561 20H559V133H561H563V20H561ZM541 153V151H473V153V155H541V153ZM453 173H451V195H453H455V173H453ZM433 215V213H20V215V217H433V215ZM20 215V213C10.0589 213 2 204.941 2 195H0H-2C-2 207.15 7.84974 217 20 217V215ZM0 195H2V121H0H-2V195H0ZM20 101V103H60V101V99H20V101ZM80 81H82V20H80H78V81H80ZM100 0V2H541V0V-2H100V0ZM80 20H82C82 10.0589 90.0589 2 100 2V0V-2C87.8497 -2 78 7.84974 78 20H80ZM453 195H451C451 204.941 442.941 213 433 213V215V217C445.15 217 455 207.15 455 195H453ZM60 101V103C72.1503 103 82 93.1503 82 81H80H78C78 90.9411 69.9411 99 60 99V101ZM473 153V151C460.85 151 451 160.85 451 173H453H455C455 163.059 463.059 155 473 155V153ZM0 121H2C2 111.059 10.0589 103 20 103V101V99C7.84974 99 -2 108.85 -2 121H0ZM561 133H559C559 142.941 550.941 151 541 151V153V155C553.15 155 563 145.15 563 133H561Z"
                fill="#F3F3F3" mask="url(#path-1-inside-1_270_167)" />
            </svg>
      
          </div>
      
          <div class="svg-content-section">
            <div class="round-img">
              <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
            </div>
            <div class="arrow-img" (click)="handleArrowClick()">
              <img src="assets/images/svg-img-arrow.png" alt="section-4-arrow-img">
            </div>
      
            <div class="svg-content">
              <div class="svg-content-header">
                <div class="round-img-inner">
                  <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
                </div>
                <h3>{{'Manage provident fund with CNSS' | translate}}</h3>
              </div>
             
              <p>{{'Simplify social security management, contributions, and benefits.' | translate}}</p>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>

  <div class="section-4-bottom">
    <div class="section-4-bottom-content-1">
      <div class="svg-card-home">
        <div class="svg-div">
          <svg class="svg-img" viewBox="0 0 561 215" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_270_167" fill="white">
              <path
                d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z" />
            </mask>
            <path
              d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z"
              fill="var(--primary-blue)" fill-opacity="0.02" />
            <path
              d="M541 0V2C550.941 2 559 10.0589 559 20H561H563C563 7.84974 553.15 -2 541 -2V0ZM561 20H559V133H561H563V20H561ZM541 153V151H473V153V155H541V153ZM453 173H451V195H453H455V173H453ZM433 215V213H20V215V217H433V215ZM20 215V213C10.0589 213 2 204.941 2 195H0H-2C-2 207.15 7.84974 217 20 217V215ZM0 195H2V121H0H-2V195H0ZM20 101V103H60V101V99H20V101ZM80 81H82V20H80H78V81H80ZM100 0V2H541V0V-2H100V0ZM80 20H82C82 10.0589 90.0589 2 100 2V0V-2C87.8497 -2 78 7.84974 78 20H80ZM453 195H451C451 204.941 442.941 213 433 213V215V217C445.15 217 455 207.15 455 195H453ZM60 101V103C72.1503 103 82 93.1503 82 81H80H78C78 90.9411 69.9411 99 60 99V101ZM473 153V151C460.85 151 451 160.85 451 173H453H455C455 163.059 463.059 155 473 155V153ZM0 121H2C2 111.059 10.0589 103 20 103V101V99C7.84974 99 -2 108.85 -2 121H0ZM561 133H559C559 142.941 550.941 151 541 151V153V155C553.15 155 563 145.15 563 133H561Z"
              fill="#F3F3F3" mask="url(#path-1-inside-1_270_167)" />
          </svg>

        </div>

        <div class="svg-content-section">
          <div class="round-img">
            <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
          </div>
          <div class="arrow-img" (click)="handleArrowClick()">
            <img src="assets/images/svg-img-arrow.png" alt="section-4-arrow-img">
          </div>

          <div class="svg-content">
            <div class="svg-content-header">
              <div class="round-img-inner">
                <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
              </div>
              <h3>{{'Get your live report on dashboard' | translate}}</h3>
            </div>
            <p>{{'Track contributions, registrations, and system activity in real time.' | translate}}</p>
          </div>
        </div>
      </div>

      <div class="svg-card-home">
        <div class="svg-div">
          <svg class="svg-img" viewBox="0 0 561 215" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_270_167" fill="white">
              <path
                d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z" />
            </mask>
            <path
              d="M541 0C552.046 0 561 8.95431 561 20V133C561 144.046 552.046 153 541 153H473C461.954 153 453 161.954 453 173V195C453 206.046 444.046 215 433 215H20C8.95431 215 0 206.046 0 195V121C0 109.954 8.95431 101 20 101H60C71.0457 101 80 92.0457 80 81V20C80 8.95431 88.9543 0 100 0H541Z"
              fill="var(--primary-blue)" fill-opacity="0.02" />
            <path
              d="M541 0V2C550.941 2 559 10.0589 559 20H561H563C563 7.84974 553.15 -2 541 -2V0ZM561 20H559V133H561H563V20H561ZM541 153V151H473V153V155H541V153ZM453 173H451V195H453H455V173H453ZM433 215V213H20V215V217H433V215ZM20 215V213C10.0589 213 2 204.941 2 195H0H-2C-2 207.15 7.84974 217 20 217V215ZM0 195H2V121H0H-2V195H0ZM20 101V103H60V101V99H20V101ZM80 81H82V20H80H78V81H80ZM100 0V2H541V0V-2H100V0ZM80 20H82C82 10.0589 90.0589 2 100 2V0V-2C87.8497 -2 78 7.84974 78 20H80ZM453 195H451C451 204.941 442.941 213 433 213V215V217C445.15 217 455 207.15 455 195H453ZM60 101V103C72.1503 103 82 93.1503 82 81H80H78C78 90.9411 69.9411 99 60 99V101ZM473 153V151C460.85 151 451 160.85 451 173H453H455C455 163.059 463.059 155 473 155V153ZM0 121H2C2 111.059 10.0589 103 20 103V101V99C7.84974 99 -2 108.85 -2 121H0ZM561 133H559C559 142.941 550.941 151 541 151V153V155C553.15 155 563 145.15 563 133H561Z"
              fill="#F3F3F3" mask="url(#path-1-inside-1_270_167)" />
          </svg>

        </div>

        <div class="svg-content-section">
          <div class="round-img">
            <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
          </div>
          <div class="arrow-img" (click)="handleArrowClick()">
            <img src="assets/images/svg-img-arrow.png" alt="section-4-arrow-img">
          </div>

          <div class="svg-content">
            <div class="svg-content-header">
              <div class="round-img-inner">
                <img src="assets/images/svg-img-round.png" alt="section-4-round-img">
              </div>
              <h3>{{'Gain management and monitoring autonomy' | translate}}</h3>
            </div>
      
            <p>{{'Empower contributors and employers with self-service tools and transparency.' | translate}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section-4-bottom-content-2">
      <div class="img-div">
        <img src="assets/images/section-4-bottom-img.png" alt="section-4-bottom-img">
      </div>
    </div>
  </div>
</div>

<div class="home-faq-section" *ngIf="faqDetails && faqDetails?.length > 0">
  <h3>{{'Frequently asked Questions' | translate}}</h3>

  <div class="faq-home-section-inner">
    <div class="faq-content" *ngFor="let faqlist of faqDetails; let i = index;">
      <div class="faq-head-div" (click)="toggleAnswer(i)">
        <h4>{{ faqlist.question }}</h4>

        <span>
          <i class="fa" [ngClass]="{'fa-plus': !openFaqIndices.has(i), 'fa-minus': openFaqIndices.has(i)}" aria-hidden="true"></i>
        </span>
      </div>

      <div class="faq-content-text" [ngClass]="{'open' : openFaqIndices.has(i)}">
        <p>{{ faqlist.answer }}</p>
      </div>
    </div>

  </div>
</div>
<app-footer></app-footer>








<!-- <section class="top-section home-sec">
  <div class="container-fluid nav-bar">
    <div id="menuOverlay" (click)="closeNav()"></div>
    <div id="mySidenav" class="sidenav">
      <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
      <div *ngIf="isBusiness || employee" class="profile-container text-center">
        <a *ngIf="!employee" routerLink="/profile">{{ accountDetails?.company_name | slice:0:15}}{{ accountDetails?.company_name?.length > 15 ? '..' : '' }}</a>

        <a *ngIf="employee" routerLink="/profile">{{ accountDetails?.first_name | slice:0:15}}{{ accountDetails?.first_name?.length > 15 ? '..' : '' }}</a>
      </div>
      <li *ngIf="login == '2' || isBusiness"> <a routerLink="/dashboard" class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a> </li>
      
      <li *ngIf="isBusiness"><a *ngIf="login == '1'" [ngClass]="{ 'active': url == 'employees'}" class="active" routerLink="/employees">{{'Employees' | translate}}</a></li>
      <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()">{{'DTS' | translate}} </a></li>

      <li>
        <a *ngIf="login == '2'" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
      </li>
      <li>
        <a routerLink="/experience" *ngIf="login == '2'">{{'Experience' | translate}}</a>
      </li>
      <li>
        <a routerLink="/cnss" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
      </li>
      <li>
        <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
      </li>
      <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li>
      <li *ngIf="login"><a routerLink="/profile">{{'Profile' | translate}}</a></li>
      <li><a routerLink="/contact-us">{{'Contact' | translate}}</a></li>
      <li *ngIf="currentValue && loginStatus == 0"><a (click)="openChangePassword()">{{'Change Password' | translate}}</a></li>
      <li [hidden]="!currentValue"><a href="" (click)="logout()">{{'Logout' | translate}}</a></li>
      <li [hidden]="currentValue" class="pulse">
        <a class="register-button" data-toggle="modal" data-target="#signupModal" (click)="closeNav()">{{'Register' | translate}}</a>
      </li>
      <li [hidden]="currentValue">
        <a class="login-button" data-toggle="modal" data-target="#signinModal" (click)="closeNav()">{{'Login' | translate}}</a>
      </li>
      <div class="language-container">
        <form [formGroup]="languageForm">

          <div class="toggle-button-cover">
            <div class="button-cover">
              <div class="button r" id="button-6">
                <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="main">
      <header class="block-header home-header">
        <div class="container-custom">
          <div class="row justify-content-between sub-nav">
            <div class="button_container">
              <div (click)="openNav()"><span class="top"></span><span class="middle"></span><span class="bottom">
                </span></div>
            </div>
            <div class="col-sm-2 col-md-2">
              <a data-aos="fade-down" data-aos-delay="400" data-aos-duration="1500" class="logo-block" routerLink="">PUPS</a>
            </div>
            <div class="col-10 justify-content-end align-items-center lang-desktop" data-aos="fade-down" data-aos-delay="400" data-aos-duration="1500">

              <ul class="mr-1">
                <li *ngIf="login == '2' || isBusiness"> <a routerLink="/dashboard" [ngClass]="{ 'active': url == 'dashboard'}">{{'Registration' | translate}}</a> </li>
                 
                <li *ngIf="isBusiness"><a *ngIf="login == '1'" [ngClass]="{ 'active': url == 'employees'}" class="active" routerLink="/employees">{{'Employees' | translate}}</a></li>
                <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()">{{'DTS' | translate}} </a></li>

                <li>
                  <a *ngIf="login == '2'" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
                </li>
                <li>
                  <a routerLink="/experience" *ngIf="login == '2'">{{'Experience' | translate}}</a>
                </li>
                <li>
                  <a routerLink="/cnss" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
                </li>
                <li>
                  <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
                </li>
                <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li>

                <li *ngIf="currentValue && loginStatus == 0"><a (click)="openChangePassword()">{{'Change Password' | translate}}</a></li>
                <li [hidden]="!currentValue"><a routerLink="/" (click)="logout()">{{'Logout' | translate}}</a></li>
              </ul>
              <div class="dropdown">
                <div class="toggle-button-cover">
                  <div class="button-cover">
                    <div class="button r" id="button-6">
                      <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="button_container" (click)="openNav()"><span class="top"></span><span class="middle"></span><span class="bottom">
              </span></div>
          </div>
          <hr>
          <div class="top-nav-container">
            <div class="row align-items-center">
              <div class="col-sm-12">
                <div class="row justify-content-end sub-nav">

                  <ul class="nav-block link-efx justify-content-end" id="page-menu">

                    <li>
                    <li [hidden]="currentValue" class="pulse">
                      <a class="register-button" (click)="showSignUp()" data-aos="fade-down" data-aos-delay="400" data-aos-duration="1500">{{'Register' | translate}}</a>
                    </li>
                    <li [hidden]="currentValue">
                      <a class="register-button" data-toggle="modal" (click)="showLogin()" data-aos="fade-down" data-aos-delay="400" data-aos-duration="1500">{{'Login' | translate}}</a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
  <div class="carousel-container">
    <div class="button-container">
      <div class="nxt_icon">

      </div>
    </div>
    <div class="owl-carousel owl-theme" id="service_slider">
      <div class="item">
        <img src="assets/images/background-green.jpg" class="bg webview" loading="lazy">
        <img src="assets/images/mob.png" class="bg mobview" loading="lazy">
        <div class="content">
          <div class="logo-container mobile-ui1">
            <div class="logo2">
              <img src="assets/images/CNSS-logo-col.png">
            </div>
            <div class="line"></div>
            <div class="logo">
              <img src="assets/images/CNAMGS_col.png">
            </div>
          </div>
          <h2 class="mobile-ui">{{'title 1' | translate }} <br> {{'title 2' | translate }}<br>{{'title 3' | translate }}</h2>
        </div>
      </div>
      <div class="item">
        <img src="assets/images/banner.jpg" class="bg" loading="lazy">
        <div class="content">
          <div class="logo-container mobile-ui1">
            <div class="logo2">
              <img src="assets/images/cnssLogo.png">
            </div>
            <div class="line"></div>
            <div class="logo">
              <img src="assets/images/CNAMGS_logo.png">
            </div>
          </div>
          <h2 class="mobile-ui">{{'title 1' | translate }} <br> {{'title 2' | translate }}</h2>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div class="nxt_icon">

      </div>
    </div>
  </div>
</section>
<section class="middle-section container">
  <div class="custom-container row">
    <div class="custom-card col-md-6 col-lg-3 col-xl-3 col-sm-12" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500">
      <div class="card-top">
        <h6>{{'Step' | translate}} 1</h6>
        <div class="icon-container">
          <img src="assets/images/key_icon.png">
        </div>
      </div>
      <div class="card-content">
        <h6>{{'Register with PUPS Website' | translate}}</h6>

      </div>
    </div>
    <div class="custom-card col-md-6 col-lg-3 col-xl-3 col-sm-12" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500">
      <div class="card-top">
        <h6>{{'Step' | translate}} 2</h6>
        <div class="icon-container">
          <img src="assets/images/link-icon.png">
        </div>
      </div>
      <div class="card-content">
        <h6>{{'Link your Account with PUPS ID' | translate}}</h6>
      </div>
    </div>
    <div class="custom-card col-md-6 col-lg-3 col-xl-3 col-sm-12" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500">
      <div class="card-top">
        <h6>{{'Step' | translate}} 3</h6>
        <div class="icon-container">
          <img src="assets/images/settings_icon.png">
        </div>
      </div>
      <div class="card-content">
        <h6>{{'Manage your company with PUPS' | translate}}</h6>
      </div>
    </div>
  </div>
  <div class="container-fluid custom-container2">
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-6 col-sm-12">
        <div class="parent-container">
          <div class="text-container">
            <h6 class="title-medium">{{'About' | translate}}</h6>
            <h5 data-scroll data-splitting>{{'about head' | translate}}</h5>
            <p data-aos="fade-right" data-aos-delay="700" data-aos-duration="1500">{{'about para 1' | translate }}</p>
            <p data-aos="fade-right" data-aos-delay="700" data-aos-duration="1500">{{'about para 2' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-5 col-sm-12">
        <div class="image-container">
          <img src="assets/images/person1.png" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="100">
        </div>
      </div>
    </div>
    <div class="dots">
      <img src="assets/images/dots.png">
    </div>
  </div>
</section>

<section class="bottom-section">
  <div class="text-container">
    <h5 class="title-green-lg">{{'Our Features' | translate}}</h5>
  </div>
  <div class="custom-container">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-4 offset-xl-1 col-sm-12">
        <div class="image-container">
          <img src="assets/images/feature_image1.png">
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-5 col-sm-12">
        <div class="parent-container">
          <div class="text-container">
            <h6>CNAMGS</h6>
            <h5 class="title-green-md">{{'Manage health insurance with CNAMGS' | translate}}</h5>
            <p class="para-green-md">{{'cnamgs-text' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="custom-container container2">
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-5 col-sm-12 element1">
        <div class="parent-container">
          <div class="text-container">
            <h6>CNSS</h6>
            <h5 class="title-green-md">{{'Manage provident fund with CNSS' | translate}}</h5>
            <p class="para-green-md">{{'cnss-text' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-5 col-sm-12 element2">
        <div class="image-container">
          <img src="assets/images/feature_image2.png">
        </div>
      </div>
    </div>
  </div>
  <div class="custom-container">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-4 offset-xl-1  col-sm-12">
        <div class="image-container">
          <img src="assets/images/feature_image3.png">
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-5 col-sm-12">
        <div class="parent-container">
          <div class="text-container">
            <h6>{{'STATITICS' | translate}}</h6>
            <h5 class="title-green-md">{{'Get your live report on dashboard' | translate}}</h5>
            <p class="para-green-md">{{'statics-test' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="custom-container container2">
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-5 col-sm-12 element1">
        <div class="parent-container">
          <div class="text-container">
            <h6>ASSURES</h6>
            <h5 class="title-green-md">{{'Gain management and monitoring autonomy' | translate}}</h5>
            <p class="para-green-md">{{'ASSURES-text' | translate}}</p>
            <p class="para-green-md">{{'ASSURES-text2' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-5 col-sm-12 element2">
        <div class="image-container">
          <img src="assets/images/feature_image4.png">
        </div>
      </div>
    </div>
  </div>
</section>  -->
<!-- <app-footer></app-footer> -->
<div *ngIf="currentValue"><app-add-bank></app-add-bank></div>

<section class="modal-section">

  <div class="modal fade" id="signinModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
        aria-labelledby="shareModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeSignInModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="modal-image-container">
            <!-- <h5 class="modal-title title-medium" id="exampleModalLongTitle">
              <div class="logo-div">
              <img src="assets/images/inner-logo.svg" alt="">
            </div>
          </h5> -->

          </div>
          <div id="signin_as" class="text-container">
            <h5 class="title-medium">{{'Sign In As' | translate}}</h5>

            <div class="button-container">
              <!-- <button type="button" class="btn btn-main" (click)="showSignInForm(2)">{{'Employee' | translate}}</button>
              <h6>{{'or' | translate}}</h6> -->
              <button type="button" class="btn btn-main" (click)="showSignInForm(1)">{{'Employer' | translate}}</button>
            </div>
          </div>
          <div id="signin" class="text-container">
            <h5 class="title-medium">{{'Sign In' | translate}}</h5>

            <form class="form-container" [formGroup]="signInForm" (ngSubmit)="onSubmitSignIn()">
              <div class="backarrow">
                <a (click)="goBack()"><i class="fa-solid fa-angle-left"></i></a>
              </div>
              <div class="input-container">
                <div class="child-container" *ngIf="employeeSignin" id="show">
                  <label class="labeltxt">{{'Email' | translate}}</label>
                  <input type="text" name="ccps_id" formControlName="ccps_id" maxlength="100">
                  <div *ngIf="isSubmitted && g.ccps_id.errors" class="invalid-feedback">
                    <div *ngIf="g.ccps_id.errors?.required">{{'Email'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="g.ccps_id.errors?.pattern">{{'Email'|translate}} {{'should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container" *ngIf="!employeeSignin">
                  <label class="labeltxt">{{'Email' | translate}}</label>
                  <input type="text" name="phone" formControlName="phone" maxlength="100" >
                  <div *ngIf="isSubmitted && g.phone.errors" class="invalid-feedback">
                    <div *ngIf="g.phone.errors?.required">{{'Email'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="g.phone.errors?.pattern">{{'Email' | translate}} {{'should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Password' | translate}}</label>
                  <div>
                    <input type="password" name="Password" id="password2" formControlName="password">
                    <span class="eye-icon" (click)="eyeclose('5')"><i id="eye2" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && g.password.errors" class="invalid-feedback">
                    <div *ngIf="g.password.errors?.required">{{'Password'|translate}} {{'is required'|translate}}</div>
                  </div>
                </div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Sign In' | translate}}</button>
            </form>
            <!-- <p *ngIf="!employeeSignin" class="small-txt">{{'No Account' | translate}} <button id="show-signup" (click)="showSignup()">{{'Sign Up New' | translate}}</button></p> -->
            <p class="small-txt forgot-password" (click)="showForgotPassword()">{{'Forgot your password?' | translate}}</p>
          </div>
          <div id="otpSignIn" class="text-container">
            <h5 class="title-medium">{{'Sign In' | translate}}</h5>
            <p>{{'Enter your OTP for sign in' | translate}}</p>
            <form class="form-container" [formGroup]="otpFormSignIn" (ngSubmit)="onSubmitSignInOtp()">
              <div class="otp-container">
                <div class="otp-input signInOtp">
                  <input type="tel" formControlName="otp1" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp2" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp3" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp4" #otpInputs maxlength="1" minlength="1" class="input" />
                </div>
                <div *ngIf="isSubmitted">
                  <div *ngIf="i.otp1.errors?.required || i.otp2.errors?.required || i.otp3.errors?.required || i.otp4.errors?.required" class="invalid-feedback">{{'OTP'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="(i.otp1.value || i.otp2.value || i.otp3.value || i.otp4.value) && (i.otp1.errors?.pattern || i.otp2.errors?.pattern || i.otp3.errors?.pattern || i.otp4.errors?.pattern)" class="invalid-feedback">{{'OTP'|translate}} {{'is not valid'|translate}}</div>
                </div>
              </div>
              <p [hidden]="!isCountDown" id="timer">{{ secondsLeft }} {{'Seconds remaining' | translate}}</p>
              <p [hidden]="isCountDown" id="resend-otp" (click)="resendOtp()">{{'Resend OTP' | translate}}</p>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Sign In' | translate}}</button>
            </form>
            <!-- <p *ngIf="!employeeSignin" class="small-txt">{{'No Account' | translate}} <button id="show-signup" (click)="showSignup()">{{'Sign Up New' | translate}}</button></p> -->
          </div>
          <div id="forgotPassword" class="text-container">
            <h5 class="title-medium">{{'Forgot Password' | translate}}</h5>

            <form class="form-container" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotPassword()">
              <div class="input-container fp-container">
                <div class="child-container">
                  <label class="labeltxt">{{'Email' | translate}}</label>
                  <input type="text" name="phone" formControlName="phone_no" maxlength="100" >
                  <div *ngIf="isSubmitted && j.phone_no.errors" class="invalid-feedback">
                    <div *ngIf="j.phone_no.errors?.required">{{'Email'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="j.phone_no.errors?.pattern">{{'Email' | translate}} {{'should be valid' | translate}}</div>
                  </div>
                </div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Submit' | translate}}</button>
            </form>
            <p [hidden]="forgotPassword" class="small-txt forgot-password" (click)="showForgotPassword()">{{'Forgot your password?' | translate}}</p>
          </div>
          <div id="forgotPasswordOtp" class="text-container">
            <h5 class="title-medium">{{'Forgot Password' | translate}}</h5>
            <p>{{'Enter your OTP to Reset Password' | translate}}</p>
            <form class="form-container" [formGroup]="otpFormForgotPassword" (ngSubmit)="onSubmitForgotOtp()">
              <div class="otp-container">
                <div class="otp-input signInOtp">
                  <input type="tel" formControlName="otp1" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp2" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp3" #otpInputs maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp4" #otpInputs maxlength="1" minlength="1" class="input" />
                </div>
                <div *ngIf="isSubmitted">
                  <div *ngIf="k.otp1.errors?.required || k.otp2.errors?.required || k.otp3.errors?.required || k.otp4.errors?.required" class="invalid-feedback">{{'OTP'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="(k.otp1.value || k.otp2.value || k.otp3.value || k.otp4.value) && (k.otp1.errors?.pattern || k.otp2.errors?.pattern || k.otp3.errors?.pattern || k.otp4.errors?.pattern)" class="invalid-feedback">{{'OTP'|translate}} {{'is not valid'|translate}}</div>
                </div>
              </div>
              <p [hidden]="!isCountDown" id="timer">{{ secondsLeft }} {{'Seconds remaining' | translate}}</p>
              <p [hidden]="isCountDown" id="resend-otp" (click)="resendOtp()">{{'Resend OTP' | translate}}</p>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Verify' | translate}}</button>
            </form>
          </div>
          <div id="resetPassword" class="text-container">
            <h5 class="title-medium">{{'Reset Password' | translate}}</h5>
            <p>{{'Create New Password' | translate}}</p>
            <form class="form-container" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPassword()">
              <div class="input-container">
                <div class="child-container">
                  <label class="labeltxt">{{'Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password" formControlName="password">
                    <span class="eye-icon" (click)="eyeclose('1')"><i id="eye" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && l.password.errors" class="invalid-feedback">
                    <div *ngIf="l.password.errors?.required">{{'Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="l.password.errors.minlength">{{'Password must be at least 8 characters'|translate}}</div>
                    <div *ngIf="l.password.errors?.pattern ">{{'password should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Confirm Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password1" formControlName="confirmPassword">
                    <span class="eye-icon" (click)="eyeclose('2')"><i id="eye1" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && l.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="l.confirmPassword.errors?.required">{{'Confirm Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="l.confirmPassword.errors.ConfirmPassword">{{'Passwords must match' | translate}}</div>
                  </div>
                </div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Verify' | translate}}</button>
            </form>
          </div>
          <div id="ChangePasswordEmployee" class="text-container">
            <h5 class="title-medium">{{'Create New Password' | translate}}</h5>

            <form class="form-container" [formGroup]="EmployeeChangePasswordForm" (ngSubmit)="onSubmitChangePassword()">
              <div class="input-container">
                <div class="child-container">
                  <label class="labeltxt">{{'Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password6" formControlName="password">
                    <span class="eye-icon" (click)="eyeclose('6')"><i id="eye6" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && m.password.errors" class="invalid-feedback">
                    <div *ngIf="m.password.errors?.required">{{'Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="m.password.errors.minlength">{{'Password must be at least 8 characters'|translate}}</div>
                    <div *ngIf="m.password.errors?.pattern ">{{'password should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Confirm Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password7" formControlName="confirmPassword">
                    <span class="eye-icon" (click)="eyeclose('7')"><i id="eye7" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && m.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="m.confirmPassword.errors?.required">{{'Confirm Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="m.confirmPassword.errors.ConfirmPassword">{{'Passwords must match' | translate}}</div>
                  </div>
                </div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Verify' | translate}}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade-scale" id="signupModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeSignUpModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="modal-image-container">
            <!-- <h5 class="modal-title title-medium" id="exampleModalLongTitle">
              <div class="logo-div">
                <img src="assets/images/inner-logo.svg" alt="">
              </div>
            </h5> -->

          </div>
          <div id="signup" class="text-container">
            <h5 class="title-medium">{{'Sign Up test' | translate}}</h5>
            <p>{{'Create your Account' | translate}}</p>
            <form class="form-container" [formGroup]="signUpForm" (ngSubmit)="onSubmitSignUp()">
              <div class="input-container">
                <div class="child-container">
                  <label for="first_name" class="labeltxt">{{'First name' | translate}}</label>
                  <input type="text" name="first_name" formControlName="first_name">
                  <div *ngIf="isSubmitted && f.first_name.errors" class="invalid-feedback">
                    <div *ngIf="f.first_name.errors?.required">{{'First name'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.first_name.errors?.pattern">{{'First name'|translate}} {{'should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Last name' | translate}}</label>
                  <input type="text" name="last_name" formControlName="last_name">
                  <div *ngIf="isSubmitted && f.last_name.errors" class="invalid-feedback">
                    <div *ngIf="f.last_name.errors?.required">{{'Last name'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.last_name.errors?.pattern">{{'Last name'|translate}} {{'should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">Email</label>
                  <input type="text" name="email" formControlName="email">
                  <div *ngIf="isSubmitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors?.required">{{'Email'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.email.errors.email || f.email.errors.pattern">{{'Email'|translate}} {{'should be valid' | translate}}</div>

                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Mobile' | translate}}</label>
                  <input type="tel" name="number" formControlName="mobile" maxlength="8" minlength="8">
                  <div class="text-sm">{{'Mobile should start with valid numbers like 77, 74, 61, 66, 62, 60, 65, 76'|translate}}</div>
                  <div *ngIf="isSubmitted && f.mobile.errors" class="invalid-feedback">
                    <div *ngIf="f.mobile.errors?.required || f.mobile.value === ''">{{'Mobile'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.mobile.hasError('pattern')">{{'Mobile'|translate}} {{'should be valid' | translate}}</div>
                    <div *ngIf="f.mobile.hasError('minlength') && !f.mobile.hasError('pattern')">{{ 'Mobile' | translate }} {{ 'must Contain 8 Numbers' | translate }}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password3" formControlName="password">
                    <span class="eye-icon" (click)="eyeclose('3')"><i id="eye3" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors?.required">{{'Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.password.errors.minlength">{{'Password must be at least 8 characters'|translate}}</div>
                    <div *ngIf="f.password.errors?.pattern ">{{'password should be valid' | translate}}</div>
                  </div>
                </div>
                <div class="child-container">
                  <label class="labeltxt">{{'Confirm Password' | translate}}</label>
                  <div>
                    <input type="password" name="number" id="password4" formControlName="confirmPassword">
                    <span class="eye-icon" (click)="eyeclose('4')"><i id="eye4" class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                  <div *ngIf="isSubmitted && f.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="f.confirmPassword.errors?.required">{{'Confirm Password'|translate}} {{'is required'|translate}}</div>
                    <div *ngIf="f.confirmPassword.errors.ConfirmPassword">{{'Passwords must match' | translate}}</div>
                  </div>
                </div>
              </div>
              <button id="submit_btn" type="submit" class="btn btn-main">{{'Sign Up' | translate}}</button>
            </form>
            <p class="small-txt">{{'Already have Account?' | translate}} <button id="show-signin" (click)="showSignin()">{{'Sign In here' | translate}}</button></p>
          </div>
          <div id="otp" class="text-container">
            <h5 class="title-medium">{{'Otp title' | translate}}</h5>
            <p>{{'Enter your OTP for sign up' | translate}}</p>
            <form class="form-container" [formGroup]="otpForm" (ngSubmit)="onSubmitOtp()">
              <div class="otp-container">
                <div class="otp-input">
                  <input type="tel" formControlName="otp1" maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp2" maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp3" maxlength="1" minlength="1" class="input" />
                  <input type="tel" formControlName="otp4" maxlength="1" minlength="1" class="input" />
                </div>
                <div *ngIf="isSubmitted">
                  <div *ngIf="h.otp1.errors?.required || h.otp2.errors?.required || h.otp3.errors?.required || h.otp4.errors?.required" class="invalid-feedback">{{'OTP'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="(h.otp1.value || h.otp2.value || h.otp3.value || h.otp4.value) && (h.otp1.errors?.pattern || h.otp2.errors?.pattern || h.otp3.errors?.pattern || h.otp4.errors?.pattern)" class="invalid-feedback">{{'OTP'|translate}} {{'is not valid'|translate}}</div>
                </div>
              </div>
              <p [hidden]="!isCountDown" id="timer">{{ secondsLeft }} {{'Seconds remaining' | translate}}</p>
              <p [hidden]="isCountDown" id="resend-otp" (click)="resendOtp()">{{'Resend OTP' | translate}}</p>
              <button type="submit" id="submit_btn" class="btn btn-main">{{'Sign Up' | translate}}</button>
            </form>
            <p class="small-txt">{{'Already have Account?' | translate}} <button id="show-signin" (click)="showSignin()">{{'Sign In here' | translate}}</button></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="myModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false" >
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content">
          <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closemyModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            <div class="modal-body" *ngIf="block_message">
                <img src="/assets/images/bell.png" class="img-fluid">
                <p>{{block_message.message}}</p>
                <p class="copy-icon"><i (click)="copyCodeToClipboard()" class="fa-regular fa-copy"></i> Code : {{block_message?.code}}</p>
                <div class="copied-message" *ngIf="copied">{{'Copied!' | translate}}</div>
            </div>
        </div>
    </div>
</div>

</section>
<img class="d-none" src="assets/images/login_people.jpg">
<img class="d-none" src="assets/images/signbg.png">


 

<app-contact-floating></app-contact-floating>
